import { z } from 'zod';
export const TINT_FNOL_ASSISTANT_ID = '0b23f1e7-bfdf-45c3-9288-c425154f01f3';
// JSON Schema for TintClaim hardcoded
export const getClaimSchema = () => {
    return {
        notifier: {
            type: 'object',
            properties: {
                firstName: { type: 'string' },
                lastName: { type: 'string' },
                phone: { type: 'string' },
                email: { type: 'string' },
                dateOfBirth: { type: 'string' }
            }
        },
        isOwner: { type: 'boolean' },
        relationshipToHost: { type: 'string' },
        wasDriver: { type: 'boolean' },
        owner: {
            type: 'object',
            properties: {
                firstName: { type: 'string' },
                lastName: { type: 'string' },
                phone: { type: 'string' },
                email: { type: 'string' },
                dateOfBirth: { type: 'string' }
            }
        },
        driver: {
            type: 'object',
            properties: {
                firstName: { type: 'string' },
                lastName: { type: 'string' },
                phone: { type: 'string' },
                email: { type: 'string' },
                dateOfBirth: { type: 'string' }
            }
        },
        incidentInformation: {
            type: 'object',
            properties: {
                incidentType: {
                    type: 'string',
                    enum: [
                        'Collision',
                        'Theft of Vehicle',
                        'Theft of Parts / Vandalism',
                        'Glass Only Damage',
                        'Tow/Breakdown Only',
                        'Fire',
                        'Animal'
                    ]
                },
                lossType: {
                    type: 'string',
                    enum: [
                        'auto_claim_collision_with_motor_vehicle',
                        'auto_claim_collision_with_fixed_object',
                        'auto_claim_collision_with_pedestrian',
                        'auto_claim_collision_with_bicycle',
                        'auto_claim_collision_with_bus_or_train',
                        'auto_claim_fire',
                        'auto_claim_theft_of_vehicle',
                        'auto_claim_theft_of_parts',
                        'auto_claim_vandalism',
                        'auto_claim_riot_or_civil_unrest',
                        'auto_claim_glass',
                        'auto_claim_tow_or_breakdown',
                        'auto_claim_animal'
                    ]
                },
                incidentDescription: { type: 'string' }
            }
        },
        incidentLocationAddress: {
            type: 'object',
            properties: {
                street1: { type: 'string' },
                street2: { type: 'string' },
                city: { type: 'string' },
                postalCode: { type: 'string' },
                state: { type: 'string' },
                country: { type: 'string' }
            }
        },
        incidentTime: {
            type: 'object',
            properties: {
                incidentTimezone: { type: 'string' },
                incidentLocalDateAndTime: { type: 'string' },
                incidentDateAndTimeUTC: { type: 'string' }
            }
        },
        incidentDetailsCollision: {
            type: 'object',
            properties: {
                factsOfLoss: { type: 'string' },
                weatherConditions: {
                    type: 'string',
                    enum: ['clear', 'sunny', 'cloudy', 'fog', 'ice', 'hail', 'sleet', 'rain', 'snow', 'wind']
                },
                roadType: {
                    type: 'string',
                    enum: ['motorway', 'dual_carriageway', 'national', 'local', 'offroad', 'car_park']
                },
                roadMarkings: {
                    type: 'string',
                    enum: ['line', 'double_line', 'dashed_line', 'none', 'two_plus_one']
                },
                speedLimit: { type: 'string' },
                numberOfVehiclesInvolved: { type: 'number' },
                numberOfPassengersInInsuredVehicle: { type: 'number' },
                numberOfPassengersInOtherVehicles: { type: 'number' },
                totalNumberOfPassengersInAllVehicles: { type: 'number' }
            }
        },
        incidentDetailsTheftOfVehicle: {
            type: 'object',
            properties: {
                natureOfTheft: {
                    type: 'string',
                    enum: [
                        'stolen_unrecovered',
                        'stolen_recovered',
                        'attempted_theft',
                        'theft_of_personal_effects',
                        'theft_of_parts',
                        'theft_of_keys',
                        'other'
                    ]
                },
                factsOfLoss: { type: 'string' },
                wasVehicleLocked: {
                    type: 'string',
                    enum: ['true', 'false', 'unknown']
                },
                glassOrDebrisAtLocation: { type: 'boolean' },
                howWasVehicleDiscoveredStolen: { type: 'string' },
                howWasVehicleStolen: { type: 'string' },
                lastActivityWithVehicle: { type: 'string' },
                lastDrivenBy: { type: 'string' },
                numberOfKeysOwned: { type: 'number' },
                vehicleHasBeenRecovered: { type: 'boolean' },
                wereKeysInVehicle: {
                    type: 'string',
                    enum: ['true', 'false', 'unknown']
                }
            }
        },
        incidentDetailsTheftOfPartsVandalism: {
            type: 'object',
            properties: {
                factsOfLoss: { type: 'string' },
                wasVehicleLocked: {
                    type: 'string',
                    enum: ['true', 'false', 'unknown']
                },
                numberOfKeysOwned: { type: 'number' },
                wereKeysInVehicle: {
                    type: 'string',
                    enum: ['true', 'false', 'unknown']
                }
            }
        },
        incidentDetailsGlassOnlyDamage: {
            type: 'object',
            properties: {
                causeOfDamage: {
                    type: 'string',
                    enum: ['impact_by_an_object', 'vandalism', 'weather', 'other']
                },
                factsOfLoss: { type: 'string' }
            }
        },
        incidentDetailsTowOrBreakdownOnly: {
            type: 'object',
            properties: {
                type: {
                    type: 'string',
                    enum: ['lockout', 'tow', 'accident_tow', 'fuel_delivery', 'jump_start', 'tire_change']
                },
                factsOfLoss: { type: 'string' }
            }
        },
        incidentDetailsFire: {
            type: 'object',
            properties: {
                natureOfFire: {
                    type: 'string',
                    enum: ['electrical_fire', 'mechanical_fire', 'arson', 'unknown']
                },
                factsOfLoss: { type: 'string' },
                lastDrivenBy: { type: 'string' },
                lastActivityWithVehicle: { type: 'string' },
                lastServicedAt: { type: 'string' },
                lastServicedBy: { type: 'string' },
                vehicleLocationType: { type: 'string' },
                whyWasVehicleAtLocation: { type: 'string' }
            }
        },
        incidentDetailsAnimal: {
            type: 'object',
            properties: {
                animalType: { type: 'string' },
                incidentComments: { type: 'string' },
                factsOfLoss: { type: 'string' }
            }
        },
        vehicle: {
            type: 'object',
            properties: {
                make: { type: 'string' },
                model: { type: 'string' },
                year: { type: 'string' },
                vin: { type: 'string' },
                policyNumber: { type: 'string' }
            }
        },
        damageDetails: {
            type: 'object',
            properties: {
                drivable: { type: 'boolean' },
                hasDamage: { type: 'boolean' },
                damageDescription: { type: 'string' }
            }
        },
        loanOrLien: {
            type: 'object',
            properties: {
                hasLoanOrLien: { type: 'boolean' },
                details: { type: 'string' }
            }
        },
        policeReport: {
            type: 'object',
            properties: {
                wasPoliceReportTaken: { type: 'boolean' },
                filledReport: {
                    type: 'object',
                    properties: {
                        agency: { type: 'string' },
                        reportNumber: { type: 'string' }
                    }
                },
                whyPoliceReportNotTaken: { type: 'string' }
            }
        },
        isAskingForDenialLetter: { type: 'boolean' },
        statement: { type: 'string' },
        notes: { type: 'string' },
        injuries: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    firstName: { type: 'string' },
                    lastName: { type: 'string' },
                    injuredPerson: {
                        type: 'string',
                        enum: ['third-party', 'insured']
                    },
                    injuryDescription: { type: 'string' }
                }
            }
        },
        otherVehicles: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    driver: {
                        type: 'object',
                        properties: {
                            firstName: { type: 'string' },
                            lastName: { type: 'string' }
                        }
                    },
                    make: { type: 'string' },
                    model: { type: 'string' },
                    year: { type: 'string' },
                    insurer: { type: 'string' },
                    policyNumber: { type: 'string' },
                    isVehicleDrivable: { type: 'boolean' },
                    damageDescription: { type: 'string' }
                }
            }
        },
        goingToFrom: { type: 'string' }
    };
};
// Zod schema for auto intake validation
const incidentTypeEnum = z.enum([
    'Collision',
    'Theft of Vehicle',
    'Theft of Parts / Vandalism',
    'Glass Only Damage',
    'Tow/Breakdown Only',
    'Fire',
    'Animal'
]);
const lossTypeEnum = z.enum([
    'auto_claim_collision_with_motor_vehicle',
    'auto_claim_collision_with_fixed_object',
    'auto_claim_collision_with_pedestrian',
    'auto_claim_collision_with_bicycle',
    'auto_claim_collision_with_bus_or_train',
    'auto_claim_fire',
    'auto_claim_theft_of_vehicle',
    'auto_claim_theft_of_parts',
    'auto_claim_vandalism',
    'auto_claim_riot_or_civil_unrest',
    'auto_claim_glass',
    'auto_claim_tow_or_breakdown',
    'auto_claim_animal'
]);
const notifierSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    phone: z
        .string()
        .regex(/^\d{10}$/, 'Phone number must be exactly 10 digits')
        .optional(),
    email: z.string().email('Invalid email address').optional(),
    dateOfBirth: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date of birth must be ISO formatted (YYYY-MM-DD)')
        .optional()
});
const ownerSchema = z.object({
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    phone: z.string().min(1, 'Phone number is required'),
    email: z.string().email('Invalid email address').min(1, 'Email is required'),
    dateOfBirth: z.string().optional()
});
const driverSchema = z.object({
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    phone: z
        .string()
        .regex(/^\d{10}$/, 'Phone number must be exactly 10 digits')
        .optional(),
    email: z.string().email('Invalid email address').optional(),
    dateOfBirth: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date of birth must be ISO formatted (YYYY-MM-DD)')
        .min(1, 'Date of birth is required')
});
const incidentInformationSchema = z.object({
    incidentType: incidentTypeEnum,
    lossType: lossTypeEnum,
    incidentDescription: z.string().min(1, 'Incident description is required')
});
const incidentLocationAddressSchema = z.object({
    street1: z.string().min(1, 'Street address is required'),
    street2: z.string().optional(),
    city: z.string().min(1, 'City is required'),
    postalCode: z.string().optional(),
    state: z.string().min(1, 'State is required'),
    country: z.string().min(1, 'Country is required')
});
const incidentTimeSchema = z.object({
    incidentTimezone: z.string().min(1, 'Incident timezone is required'),
    incidentLocalDateAndTime: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/, 'Local date and time must be in format YYYY-MM-DD HH:MM')
        .min(1, 'Incident local date and time is required'),
    incidentDateAndTimeUTC: z
        .string()
        .min(1, 'Incident UTC date and time is required')
        .refine((val) => !isNaN(Date.parse(val)), 'must be a valid date and time')
});
const collisionIncidentDetailSchema = z.object({
    factsOfLoss: z.string().min(1, 'Facts of loss is required'),
    weatherConditions: z
        .enum(['clear', 'sunny', 'cloudy', 'fog', 'ice', 'hail', 'sleet', 'rain', 'snow', 'wind'])
        .optional(),
    roadType: z.enum(['motorway', 'dual_carriageway', 'national', 'local', 'offroad', 'car_park']).optional(),
    roadMarkings: z.enum(['line', 'double_line', 'dashed_line', 'none', 'two_plus_one']).optional(),
    speedLimit: z.string().optional(),
    numberOfVehiclesInvolved: z.number().int().positive().optional(),
    numberOfPassengersInInsuredVehicle: z.number().int().nonnegative().optional(),
    numberOfPassengersInOtherVehicles: z.number().int().nonnegative().optional(),
    totalNumberOfPassengersInAllVehicles: z.number().int().nonnegative().optional()
});
const theftIncidentDetailSchema = z.object({
    natureOfTheft: z
        .enum([
        'stolen_unrecovered',
        'stolen_recovered',
        'attempted_theft',
        'theft_of_personal_effects',
        'theft_of_parts',
        'theft_of_keys',
        'other'
    ])
        .optional(),
    factsOfLoss: z.string().min(1, 'Facts of loss is required'),
    wasVehicleLocked: z.enum(['true', 'false', 'unknown']),
    glassOrDebrisAtLocation: z.boolean().optional(),
    howWasVehicleDiscoveredStolen: z.string().optional(),
    howWasVehicleStolen: z.string().optional(),
    lastActivityWithVehicle: z.string().optional(),
    lastDrivenBy: z.string().optional(),
    numberOfKeysOwned: z.number().int().nonnegative().optional(),
    vehicleHasBeenRecovered: z.boolean().optional(),
    wereKeysInVehicle: z.enum(['true', 'false', 'unknown']).optional()
});
const theftPartsVandalismIncidentDetailSchema = z.object({
    factsOfLoss: z.string().min(1, 'Facts of loss is required'),
    wasVehicleLocked: z.enum(['true', 'false', 'unknown']).optional(),
    numberOfKeysOwned: z.number().int().nonnegative().optional(),
    wereKeysInVehicle: z.enum(['true', 'false', 'unknown']).optional()
});
const glassIncidentDetailSchema = z.object({
    causeOfDamage: z.enum(['impact_by_an_object', 'vandalism', 'weather', 'other']),
    factsOfLoss: z.string().min(1, 'Facts of loss is required')
});
const towOrBreakdownIncidentDetailSchema = z.object({
    type: z.enum(['lockout', 'tow', 'accident_tow', 'fuel_delivery', 'jump_start', 'tire_change']),
    factsOfLoss: z.string().min(1, 'Facts of loss is required')
});
const fireIncidentDetailSchema = z.object({
    natureOfFire: z.enum(['electrical_fire', 'mechanical_fire', 'arson', 'unknown']),
    factsOfLoss: z.string().min(1, 'Facts of loss is required'),
    lastDrivenBy: z.string().optional(),
    lastActivityWithVehicle: z.string().optional(),
    lastServicedAt: z.string().optional(),
    lastServicedBy: z.string().optional(),
    vehicleLocationType: z.string().optional(),
    whyWasVehicleAtLocation: z.string().optional()
});
const animalIncidentDetailSchema = z.object({
    animalType: z.string(),
    incidentComments: z.string().optional(),
    factsOfLoss: z.string().min(1, 'Facts of loss is required')
});
const vehicleSchema = z.object({
    make: z.string().min(1, 'Vehicle make is required'),
    model: z.string().min(1, 'Vehicle model is required'),
    year: z
        .string()
        .regex(/^\d{4}$/, 'Year must be a 4-digit year')
        .min(1, 'Vehicle year is required'),
    vin: z.string().min(1, 'VIN is required'),
    policyNumber: z.string()
});
const damageDetailsSchema = z.object({
    drivable: z.boolean().optional(),
    hasDamage: z.boolean().optional(),
    damageDescription: z.string().optional()
});
const loanOrLienSchema = z.object({
    hasLoanOrLien: z.boolean(),
    details: z.string().optional()
});
const policeReportSchema = z.object({
    wasPoliceReportTaken: z.boolean(),
    filledReport: z
        .object({
        agency: z.string().optional(),
        reportNumber: z.string().optional()
    })
        .optional(),
    whyPoliceReportNotTaken: z.string().optional()
});
const injurySchema = z.object({
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    injuredPerson: z.enum(['third-party', 'insured']),
    injuryDescription: z.string().min(1, 'Injury description is required')
});
const otherVehicleSchema = z.object({
    driver: z
        .object({
        firstName: z.string().optional(),
        lastName: z.string().optional()
    })
        .optional(),
    make: z.string().optional(),
    model: z.string().optional(),
    year: z.string().optional(),
    insurer: z.string().optional(),
    policyNumber: z.string().optional(),
    isVehicleDrivable: z.boolean().optional(),
    damageDescription: z.string().optional()
});
export const completeAutoIntakeInputSchema = z
    .object({
    notifier: notifierSchema,
    isOwner: z.boolean().optional(),
    relationshipToHost: z.string().optional(),
    wasDriver: z.boolean().optional(),
    owner: ownerSchema.optional(),
    driver: driverSchema.optional(),
    incidentInformation: incidentInformationSchema,
    incidentLocationAddress: incidentLocationAddressSchema,
    incidentTime: incidentTimeSchema,
    incidentDetailsCollision: collisionIncidentDetailSchema.optional(),
    incidentDetailsTheftOfVehicle: theftIncidentDetailSchema.optional(),
    incidentDetailsTheftOfPartsVandalism: theftPartsVandalismIncidentDetailSchema.optional(),
    incidentDetailsGlassOnlyDamage: glassIncidentDetailSchema.optional(),
    incidentDetailsTowOrBreakdownOnly: towOrBreakdownIncidentDetailSchema.optional(),
    incidentDetailsFire: fireIncidentDetailSchema.optional(),
    incidentDetailsAnimal: animalIncidentDetailSchema.optional(),
    vehicle: vehicleSchema,
    damageDetails: damageDetailsSchema.optional(),
    loanOrLien: loanOrLienSchema,
    policeReport: policeReportSchema,
    isAskingForDenialLetter: z.boolean(),
    gaveConsentForSms: z.boolean(),
    statement: z.string().min(1, 'Statement is required'),
    notes: z.string().optional(),
    injuries: z.array(injurySchema).optional(),
    otherVehicles: z.array(otherVehicleSchema).optional(),
    goingToFrom: z.string()
})
    .refine((data) => {
    if (data.incidentInformation.incidentType === 'Collision' && !data.incidentDetailsCollision) {
        return false;
    }
    return true;
}, {
    message: 'incidentDetailsCollision is required when incidentType is Collision',
    path: ['incidentDetailsCollision']
})
    .refine((data) => {
    if (data.incidentInformation.incidentType === 'Theft of Vehicle' &&
        !data.incidentDetailsTheftOfVehicle) {
        return false;
    }
    return true;
}, {
    message: 'incidentDetailsTheftOfVehicle is required when incidentType is Theft of Vehicle',
    path: ['incidentDetailsTheftOfVehicle']
})
    .refine((data) => {
    if (data.incidentInformation.incidentType === 'Theft of Parts / Vandalism' &&
        !data.incidentDetailsTheftOfPartsVandalism) {
        return false;
    }
    return true;
}, {
    message: 'incidentDetailsTheftOfPartsVandalism is required when incidentType is Theft of Parts / Vandalism',
    path: ['incidentDetailsTheftOfPartsVandalism']
})
    .refine((data) => {
    if (data.incidentInformation.incidentType === 'Glass Only Damage' &&
        !data.incidentDetailsGlassOnlyDamage) {
        return false;
    }
    return true;
}, {
    message: 'incidentDetailsGlassOnlyDamage is required when incidentType is Glass Only Damage',
    path: ['incidentDetailsGlassOnlyDamage']
})
    .refine((data) => {
    if (data.incidentInformation.incidentType === 'Tow/Breakdown Only' &&
        !data.incidentDetailsTowOrBreakdownOnly) {
        return false;
    }
    return true;
}, {
    message: 'incidentDetailsTowOrBreakdownOnly is required when incidentType is Tow/Breakdown Only',
    path: ['incidentDetailsTowOrBreakdownOnly']
})
    .refine((data) => {
    if (data.incidentInformation.incidentType === 'Fire' && !data.incidentDetailsFire) {
        return false;
    }
    return true;
}, {
    message: 'incidentDetailsFire is required when incidentType is Fire',
    path: ['incidentDetailsFire']
})
    .refine((data) => {
    if (data.incidentInformation.incidentType === 'Animal' && !data.incidentDetailsAnimal) {
        return false;
    }
    return true;
}, {
    message: 'incidentDetailsAnimal is required when incidentType is Animal',
    path: ['incidentDetailsAnimal']
})
    .refine((data) => {
    if (data.wasDriver === false && !data.driver) {
        return false;
    }
    return true;
}, {
    message: 'driver is required when wasDriver is false',
    path: ['driver']
})
    .refine((data) => {
    if (data.isOwner === false && !data.owner) {
        return false;
    }
    return true;
}, {
    message: 'owner is required when isOwner is false',
    path: ['owner']
});
//# sourceMappingURL=claims.js.map